<div class="container-fluid d-flex flex-column login-bg">
    <div class="row">
        <div class="col text-end pt-4 pe-5">
            <div class="d-flex flex-column align-items-end">
                <button class="btn btn-outline-warning mb-3" (click)="goToAlddaMX()" style="width: 13rem;border-radius: 0.8rem !important;color:white;">VOLVER A ALDDA.MX</button>
            </div>
        </div>
    </div>
    <div class="row d-flex justify-content-center">
        <div class="col-6 text-center mt-4">
            <img class="img-fluid" src="assets/images/logo-subject-selection.svg" alt="aldda-logo">
        </div>
    </div>
    <div class="row d-flex justify-content-center mt-1">
        <div class="col-8">
            <div class="col fontuser">
                <input type="text" class="form-control mb-0 search-input" placeholder="Escriba su búsqueda" autocomplete="off" uppercase (input)="onInputChange($event)" />
                <img src="assets/icons/search-icon.svg" class="search-icon-img">
            </div>
        </div>

        <div class="col-8 mt-5">
            <div class="d-flex justify-content-center gap-5">
                <div class="icon-card p-2 col">
                    <div class="label">
                        <div class="icon">
                            <!-- You can use an icon font like Font Awesome or a Unicode character -->
                            <img src="assets/icons/Icon_Usuario.svg" />
                            <!-- <i class="fas fa-user"></i> -->
                        </div>
                        <div class="username">
                            <p class="mb-0 pb-0">USUARIO</p>
                            <b>{{userName}}</b>
                        </div>
                    </div>
                </div>
                <div class="icon-card p-2 col">
                    <div class="label">
                        <div class="icon">
                            <!-- You can use an icon font like Font Awesome or a Unicode character -->
                            <img src="assets/icons/Icon_Grupo.svg" />
                            <!-- <i class="fas fa-user"></i> -->
                        </div>
                        <div class="username">
                            <p class="mb-0 pb-0">GRUPO</p>
                            <b>{{groupName}}</b>
                        </div>
                    </div>
                </div>
                <div class="icon-card mt-auto p-2 col">
                    <div class="label">
                        <div class="icon">
                            <!-- You can use an icon font like Font Awesome or a Unicode character -->
                            <img src="assets/icons/Icon_SO.svg" />
                            <!-- <i class="fas fa-user"></i> -->
                        </div>
                        <div class="username">
                            <p class="mb-0 pb-0">Sujetos Obligados</p>
                            <b>{{subjectObligeds.length}} REGISTRADOS</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center align-items-center flex-row">

        <div class="d-flex mt-5 text-white justify-content-center align-items-center" *ngIf="subjectObligeds.length == 0 && !loading" style="width: 85%;">
            <h2 class="mt-5">No se encontraron sujetos obligados</h2>
        </div>

        <div class="d-flex mt-4" *ngIf="subjectObligeds.length > 0 && carouselTile" style="width: 85%;">
            <div [style.opacity]="assetsCarousel.isFirst ? 0.2:1" style="width: 3rem;" class="align-content-center text-white">
                <div NguCarouselPrev role="button" (click)="movePrev(assetsCarousel)" class="bg-primary rounded-circle d-flex justify-content-center align-items-center" style="height: 2.5rem;width: 2.5rem;">
                    <i class="fa fa-lg fa-chevron-left"></i></div>
            </div>

            <div class="mt-3" style="width: calc(100% - 6rem);" [className]="subjectObligeds.length < 4 ? 'carousel-center' : ''">
                <ngu-carousel #assetsCarousel [inputs]="carouselTile" [dataSource]="subjectObligeds | filter :['name','vulnerableActivity']: searchTerm">
                    <ngu-tile *nguCarouselDef="let item; let i = index" class="assets-tile px-5">
                        <div class="p-3 mt-2 align-items-center justify-content-start text-center col card" style="border-radius: 0.5rem;height: 100%;">
                            <img src="assets/icons/av/av-veh-icon.png" style="width: 40%;" />
                            <div>
                                <div class="h5 fw-bold text-primary mt-2"> {{item.name}}</div>
                                <h5 class="my-2 small"> {{item.vulnerableActivity}}</h5>
                                <h6 *ngIf="item.branchOfficeName" class="my-2 small text-muted">Sucursal {{item.branchOfficeName}}</h6>
                            </div>
                            <img src="assets/images/logo-flat.png" class="my-1 img-fluid mt-auto" />
                            <div class="justify-content-end">
                                <button class="btn btn-primary mb-1" (click)="loginAsSubjectObliged(item)">ENTRAR</button>
                            </div>
                            <div *ngIf="item.isSuspended" class="position-absolute w-100 h-100 align-items-center d-flex justify-content-center top-0 rounded" style="background-color: #ffffffaa;z-index: 10;">
                                <img src="assets/icons/cancel-icon.png" />
                            </div>
                        </div>
                    </ngu-tile>
                </ngu-carousel>
            </div>
            <div [style.opacity]="assetsCarousel.isLast ? 0.5:1" style="width: 3rem;" class="align-content-center text-white">
                <div NguCarouselNext role="button" (click)="moveNext(assetsCarousel)" class="bg-primary rounded-circle d-flex justify-content-center align-items-center" style="height: 2.5rem;width: 2.5rem;">
                    <i class="fa fa-lg fa-chevron-right"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-auto" style="margin-bottom: 2%;">
        <div class="col text-center">
            <p class="text-white">2026 © ALDDA Virtual, S.A. de C.V.</p>
        </div>
    </div>

</div>

<!-- <app-progress-indicator [visible]="loading"></app-progress-indicator> -->
